export default "__VITE_ASSET__4d8afc4f__"